import { isAfter } from "date-fns";

export const ACADEMIC_SYNC_TYPE = {
  ALL            : null,
  STANDARD       : 1,
  MASTER         : 2,
  ASSOCIATE      : 3,
  NOT_AVAILABLE  : 4,
  NOT_ASSOCIATED : 5
};

export const syncStatus = {
  NOT_SYNCHRONIZED    : 1,
  WAITING_FOR_SYNC    : 2,
  SYNCHRONIZED        : 3,
  ERROR               : 4,
  UNAVAILABLE_TO_SYNC : 5
};

export const syncStatusAlias = {
  [syncStatus.NOT_SYNCHRONIZED] : 'not-synchronized',
  [syncStatus.WAITING_FOR_SYNC] : 'waiting-for-sync',
  [syncStatus.SYNCHRONIZED]     : 'synchronized',
  [syncStatus.ERROR]            : 'error'
};

export const syncIconObject = {
  [syncStatus.UNAVAILABLE_TO_SYNC]: {
    icon  : 'mdi-file-cancel-outline',
    color : '#EF5350',
    text  : 'content.topicSyncStatus.unavailableToSync'
  },
  [syncStatus.NOT_SYNCHRONIZED]: {
    icon  : 'mdi-sync-off',
    color : '#D08300',
    text  : 'content.topicSyncStatus.notSynchronized'
  },
  [syncStatus.WAITING_FOR_SYNC]: {
    icon  : 'mdi-timer-sync-outline',
    color : '#556F83',
    text  : 'content.topicSyncStatus.waitingForSync'
  },
  [syncStatus.SYNCHRONIZED]: {
    icon  : 'mdi-sync',
    color : '#00A285',
    text  : 'content.topicSyncStatus.synchronized'
  },
  [syncStatus.ERROR]: {
    icon  : 'mdi-cancel',
    color : '#EF5350',
    text  : 'content.topicSyncStatus.error'
  }
};

export const academicMainSyncStatusObject = {
  [syncStatus.NOT_SYNCHRONIZED]: {
    icon  : 'mdi-sync-off',
    color : '#D08300',
    text  : 'content.academicMainSyncStatus.notSynchronized'
  },
  [syncStatus.WAITING_FOR_SYNC]: {
    icon  : 'mdi-timer-sync-outline',
    color : '#556F83',
    text  : 'content.topicSyncStatus.waitingForSync'
  },
  [syncStatus.SYNCHRONIZED]: {
    icon  : 'mdi-sync',
    color : '#00A285',
    text  : 'content.academicMainSyncStatus.synchronized'
  },
  [syncStatus.ERROR]: {
    icon  : 'mdi-cancel',
    color : '#EF5350',
    text  : 'content.topicSyncStatus.error'
  }
};

const _getLatestOrOlderDate = ({ dateArray, getOlder = false }) => {
  return dateArray
    .reduce((result, date) => {
      if (!result) {
        return date;
      }

      return getOlder
        ? (date < result ? date : result)
        : (date > result ? date : result);
    }, null);
};

export const getMasterSyncStatus = ({
  masterVersionAt,
  associatedAcademicMains,
  hasLocalChanges = false
}) => {
  if (hasLocalChanges) {
    return syncStatus.NOT_SYNCHRONIZED;
  }

  let hasBatchProcessNewerThenTopicVersionAt = false;
  let isMasterNewerThenAssociated = false;

  const olderAssociatedVersionDate = _getLatestOrOlderDate({
    dateArray : associatedAcademicMains.map((a) => (new Date(a.versionAt))),
    getOlder  : true
  });

  const latestBatchProcessDate = _getLatestOrOlderDate({
    dateArray: associatedAcademicMains.map((a) => (new Date(a.batchProcessCreatedAt)))
  });

  isMasterNewerThenAssociated = isAfter(new Date(masterVersionAt), olderAssociatedVersionDate);

  hasBatchProcessNewerThenTopicVersionAt = isAfter(
    new Date(latestBatchProcessDate),
    new Date(masterVersionAt)
  );

  if (masterVersionAt && !isMasterNewerThenAssociated) {
    return syncStatus.SYNCHRONIZED;
  }

  if (masterVersionAt && hasBatchProcessNewerThenTopicVersionAt) {
    const statusPriority = {
      [syncStatus.ERROR]            : 1,
      [syncStatus.WAITING_FOR_SYNC] : 2,
      [syncStatus.NOT_SYNCHRONIZED] : 3,
      [syncStatus.SYNCHRONIZED]     : 4
    };

    const statusByPriority = associatedAcademicMains.reduce((acc, associatedAcademicMain) => {
      if (statusPriority[associatedAcademicMain.syncStatus] < acc.priority) {
        acc.status = associatedAcademicMain.syncStatus;
        acc.priority = statusPriority[associatedAcademicMain.syncStatus];
      }
      return acc;
    }, { status: null, priority: 5 });

    return statusByPriority.status;
  }

  return syncStatus.NOT_SYNCHRONIZED;
};
